module.exports = __webpack_public_path__ + "static/img/emb-none.fe4d768.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/emb-none.png
// module id = tD3M
// module chunks = 3